import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  color: #36ded6;
  padding: 30px;

  .main-view {
    border-left-width: 1px;
    border-left-style: solid;

    padding-top: 5%;
    padding-bottom: 5%;

    p {
      color: #fff;
    }
  }

  .main-edit {
    margin: 0 auto;
    padding-top: 5%;
    padding-bottom: 5%;
    width: 600px;
    max-width: 600px;
  }
`;

export const ViewFormPersonal = styled.div`
  justify-content: center;
  margin-top: 20px;

  input {
    background: rgba(0, 0, 0, 0);
    border: 1px solid #36ded6;
    border-radius: 5px;
    box-sizing: border-box;
    height: 50px;
    padding: 0 15px;
    color: #fff;
    margin: 0 7px 14px;

    &::placeholder {
      color: #fff;
    }
  }

  div.support {
    display: flex;
    flex: 1;
    flex-direction: column;

    p {
      color: #fff;
      font-size: 14px;
      margin: 10px 0px 10px 10px;
    }
  }
`;

export const ViewFormLocal = styled.div`
  /* display: grid;
  grid-template-columns: 390px 100px; */

  justify-content: center;

  margin-top: 20px;

  select {
    background: rgba(0, 0, 0, 0);
    border: 1px solid #36ded6;
    border-radius: 5px;
    box-sizing: border-box;
    height: 50px;
    padding: 0 15px;
    color: #fff;
    margin: 0 7px 14px;
    font-size: 16px;

    &::placeholder {
      color: #fff;
    }
  }

  input {
    background: rgba(0, 0, 0, 0);
    border: 1px solid #36ded6;
    border-radius: 5px;
    box-sizing: border-box;
    height: 50px;
    padding: 0 15px;
    color: #fff;
    margin: 0 7px 14px;

    &::placeholder {
      color: #fff;
    }
  }

  div.support {
    display: flex;
    flex: 1;
    flex-direction: column;

    p {
      color: #fff;
      font-size: 14px;
      margin: 10px 0px 10px 10px;
    }
  }
`;

export const ViewFormPassword = styled.div`
  /* justify-content: center; */
  margin-top: 20px;

  input {
    background: rgba(0, 0, 0, 0);
    border: 1px solid #36ded6;
    border-radius: 5px;
    box-sizing: border-box;
    height: 50px;
    padding: 0 15px;
    color: #fff;
    margin: 0 7px 14px;

    &::placeholder {
      color: #fff;
    }
  }

  div.support {
    display: flex;
    flex: 1;
    flex-direction: column;

    p {
      color: #fff;
      font-size: 14px;
      margin: 10px 0px 10px 10px;
    }
  }
`;

export const ViewBottom = styled.div`
  align-items: center;
  justify-content: center;

  margin: 15px auto;
  text-align: center;

  button {
    height: 50px;
    width: 360px;
    background: #36ded6;
    font-weight: bold;
    color: #090f35;
    border: 0;
    border-radius: 5px;
    font-size: 14px;
    transition: background 0.2s;

    &:hover {
      background: ${darken(0.08, '#36ded6')};
    }
  }

  a {
    color: #36ded6;
    margin-bottom: 25px;
    font-size: 14px;
    font-weight: bold;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }
`;
